import { render } from "./QuestionAdmin.vue?vue&type=template&id=271e0c3c&scoped=true"
import script from "./QuestionAdmin.vue?vue&type=script&lang=js"
export * from "./QuestionAdmin.vue?vue&type=script&lang=js"

import "./QuestionAdmin.vue?vue&type=style&index=0&id=271e0c3c&scoped=true&lang=css"

import exportComponent from "D:\\Development\\Illyrian\\witsrhi-journeytool-myprep\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-271e0c3c"]])

export default __exports__